import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { SimpleOnPress } from '@interfaces/base';
import { DashboardScope } from '@api/domain/types';
import type { PartDashboardResult, DashboardResultImageData } from '@api/domain/types';

import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import type { Rank, RankBadgeVariant, WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';
import DashboardOverviewBottomBlockRowBadge from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowBadge';
import DashboardOverviewBottomBlockRowValue from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowValue';
import DashboardRowImage from '@v2/pages/dashboard/common/components/DashboardRowImage';
import DashboardRowWrapper from '@v2/pages/dashboard/common/components/DashboardRowWrapper';
import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';

interface DashboardOverviewBottomBlockPartRowProps
  extends WithColor,
    SimpleOnPress,
    WithBorderRadiusConfig,
    Pick<PartDashboardResult, 'partName' | 'description' | 'partId' | 'totalTimeTotalInSeconds'> {
  rank: Rank;
  variant: RankBadgeVariant;
  imageHash?: string | null;
  imageData?: DashboardResultImageData | null;
}

const DashboardOverviewBottomBlockPartRow: FC<DashboardOverviewBottomBlockPartRowProps> = ({
  C,
  rank,
  variant,
  partName,
  description,
  totalTimeTotalInSeconds,
  imageHash,
  imageData,
  onPress,
  borderRadiusConfig,
}) => (
  <DashboardRowWrapper
    onPress={onPress}
    testID={TEST_IDS.dashboardOverviewBottomBlock.row(variant, rank)}
    scope={DashboardScope.Part}
    borderRadiusConfig={borderRadiusConfig}
  >
    <DashboardOverviewBottomBlockRowBadge rank={rank} variant={variant} />
    <DashboardRowImage imageHash={imageHash} imageData={imageData} />
    <View style={{ flex: 1, gap: scale(2), marginLeft: scale(8) }}>
      <Text style={[font['Subhead 1 bold'], { color: C('Label/Light/Primary') }]} numberOfLines={1}>
        {partName ?? ''}
      </Text>
      {description && (
        <Text style={[font['Caption 2'], { color: C('Label/Light/Tertiary') }]} numberOfLines={1}>
          {description}
        </Text>
      )}
    </View>
    <DashboardOverviewBottomBlockRowValue seconds={totalTimeTotalInSeconds ?? 0} variant={variant} />
  </DashboardRowWrapper>
);

export default ColorWrapper(DashboardOverviewBottomBlockPartRow);
